class ProductShippingMessage extends HTMLElement {
  constructor() {
    super();

    this.cartUpdateUnsubscriber = undefined;
  }

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      this.checkCart()
    });
  }

  async checkCart() {
    const cart = await fetch(`${window.routes.cart_url}.js`).then(
      response => {
        if (!response.ok) {
          throw response
        }

        return response.json()
      },
    )

    if (cart) {
      const textEl = this.querySelector('[js-shipping-message="text"]')
      const qualifyingAmount = parseInt(this.dataset.qualifyingAmount)

      if (!textEl) return

      if (cart.total_price >= qualifyingAmount) {
        textEl.innerHTML = this.dataset.headingQualifying
        this.dataset.qualified = true

      } else {
        const amountLeft = (qualifyingAmount - cart.total_price) / 100
        textEl.innerHTML = this.dataset.heading.replace('[[ amount_left ]]', amountLeft.toLocaleString(undefined, { style: 'currency', currency: `${window.Shopify.currency.active}` }))
        this.dataset.qualified = false
      }
    }
  }
}

customElements.define('product-shipping-message', ProductShippingMessage);
